import { approachImage } from '@/mocks/site';

const PRINCIPLES = [
  { n: '01', title: 'Accuracy' },
  { n: '02', title: 'Judgement' },
  { n: '03', title: 'Relationships' },
];

export default function ApproachSection() {
  return (
    <section id="our-approach" className="relative flex min-h-[640px] w-full flex-col overflow-hidden bg-foreground-950 md:min-h-[88svh]">
      <img
        src={approachImage}
        alt="AVENOR advisors in conversation with a business owner"
        title="AVENOR financial advisory approach"
        className="editorial-img absolute inset-0 h-full w-full object-cover object-center"
      />
      <div aria-hidden="true" className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/55" />
      <div aria-hidden="true" className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(0,0,0,0.38)_0%,rgba(0,0,0,0.12)_55%,transparent_80%)]" />

      <div className="relative flex w-full flex-1 items-center justify-center px-4 pb-10 pt-24 md:px-6 md:pt-28">
        <div className="w-full max-w-[880px] text-center">
          <p className="font-label text-[11px] uppercase tracking-[0.18em] text-white/80">
            03 <span className="mx-2 text-white/40">/</span> Our Approach
          </p>
          <h2 className="mt-8 leading-[0.95] md:mt-10">
            <span className="block font-sans text-[46px] font-light tracking-[-0.03em] text-white sm:text-[64px] lg:text-[88px]">Beyond the</span>
            <span className="mt-1 block font-poster text-[52px] font-extrabold uppercase tracking-[0.01em] text-primary-500 sm:text-[72px] lg:text-[96px]">Figures.</span>
          </h2>
          <p className="mx-auto mt-8 max-w-[520px] text-[15px] leading-[1.7] text-white/85 md:mt-10 md:text-base">
            Numbers describe a business. Understanding them shapes its future.
          </p>
        </div>
      </div>

      <div className="relative w-full border-t border-white/20 px-4 md:px-6">
        <ul className="mx-auto flex max-w-[880px] flex-col items-center justify-center gap-3 py-6 sm:flex-row sm:gap-0 md:py-8">
          {PRINCIPLES.map((p, i) => (
            <li key={p.n} className={`flex items-baseline gap-3 whitespace-nowrap sm:px-8 md:px-12 ${i > 0 ? 'sm:border-l sm:border-white/25' : ''}`}>
              <span className="font-label text-[11px] tracking-[0.14em] text-primary-500">{p.n}</span>
              <span className="text-white/40">—</span>
              <span className="font-label text-[11px] uppercase tracking-[0.18em] text-white/90">{p.title}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}